import {useState} from 'react';
import {observer} from 'mobx-react';
import {auth} from 'main/tools';
import {QuickTip, Panel, Button} from 'shared/components';
import {AnswerResults} from 'main/components';
import {FormattedMessage} from 'react-intl';
import {absoluteDateFormatter, absoluteTimestampDate} from 'shared/tools';
import ReviewNotes from 'main/containers/performance_reviews/components/reviews/components/view/components/review_details/components/ReviewNotes';
import ShareWithRevieweeModal from '../../ShareWithRevieweeModal';
import UnshareRevieweeModal from '../../UnshareRevieweeModal';

const ReviewReader = observer(({title, description, review, onUnsubmit, onShare, onUnshare}) => {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [unshareModalOpen, setUnshareModalOpen] = useState(false);

  return (
    <Panel className='print-page-break-always'>
      {review.sharedAt && review.isManagerReview &&
        <div className='mb2'>
          <QuickTip trait='info'>
            {review.submitted ?
              <FormattedMessage
                id='performance_reviews.view.SHARED_WITH_MESSAGE'
                values={{
                  sharedAt: absoluteDateFormatter(review.sharedAt),
                  employeeName: review.reviewee.employee.name
                }}
              /> :
              <FormattedMessage
                id='performance_reviews.view.This review has been closed and can no longer be submitted'
              />
            }
          </QuickTip>
        </div>
      }
      <Panel.Header title={title}/>
      <div className='h4 jumbo mb2 print-hide'>
        {description && <i className='material-symbols-solid h3 align-middle waterloo mr1'>{'visibility'}</i>}
        {description}
      </div>
      <AnswerResults answers={review.sortedAnswers} />
      <div className='flex align-items-center justify-content-between gap-1'>
        <div className='waterloo'>
          {review.canUnsubmit && review.submittedAt &&
            <FormattedMessage
              id='performance_reviews.view.SUBMITTED'
              values={{
                submittedAt: absoluteTimestampDate(review.submittedAt)
              }}
            />
          }
        </div>
        <div className='flex gap-1'>
          {review.canUnsubmit && onUnsubmit &&
            <Button trait='default' onClick={() => onUnsubmit(review)} className='ml2'>
              <FormattedMessage id={auth.employee.id === review.reviewer.id ? 'performance_reviews.view.UNSUBMIT' : 'performance_reviews.view.UNSUBMIT_FOR_EMPLOYEE'}/>
            </Button>
          }
          {review.hasLink('share') && onShare &&
            <Button onClick={() => setShareModalOpen(true)}>
              <FormattedMessage id='performance_reviews.view.Share'/>
            </Button>
          }
          {review.hasLink('unshare') && onUnshare &&
            <Button trait='default' onClick={() => setUnshareModalOpen(true)}>
              <FormattedMessage id='performance_reviews.view.Unshare'/>
            </Button>
          }
        </div>
      </div>
      <ReviewNotes review={review} />
      <ShareWithRevieweeModal
        isOpen={shareModalOpen}
        reviewee={review.reviewee}
        onClose={() => setShareModalOpen(false)}
        onSubmit={async () => {
          await onShare(review);
          setShareModalOpen(false);
        }}
      />
      <UnshareRevieweeModal
        isOpen={unshareModalOpen}
        reviewee={review.reviewee}
        onClose={() => setUnshareModalOpen(false)}
        onSubmit={async () => {
          await onUnshare(review);
          setUnshareModalOpen(false);
        }}
      />
    </Panel>
  );
});

export default ReviewReader;
